import { Component } from '@angular/core';

@Component({
  standalone: false,
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  selector: 'toast'
})
export class ToastMessage {
  message: any;
  // message: string = '';
  messageType: string = 'string';
  showToastMessage(message: string) {
    this.dismissToast();
    // this.message = message;
    const result = this.containsPipeSymbol(message);
    console.log(result);
    if (result === true) {
      this.messageType = 'array';
      console.log('Yes');
      this.message = message.split('|');
      console.log(this.message);
    } else {
      this.messageType = 'string';
      this.message = message;
      console.log('No');
    }
    // this.message = message.replace(/\|/g, '\n').replace(/\. /g, '.<br>').trim(); // Replace each period followed by a space with a period and two <br> tags
    // this.message = message.replace(/<\/?br\s*\/?>/gi, '\n').replace(/\. /g, '.<br><br>').trim(); // Replace <br> tags with newline characters;
    var x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(() => { x.className = x.className.replace("show", ""); }, 10000);
  }

  dismissToast() {
    var x = document.getElementById("snackbar");
    x.className = x.className.replace("show", "");
    this.messageType = '';
  }

  containsPipeSymbol(message) {
    return message.includes('|');
  }
}
